export default 'M14.62 21.47 23.6 5.5A3.02 3.02 0 0 0 21 1H3A3.02 3.02 0 0 0 .4 5.5l8.98 15.97a3 3 0 0 0 5.24 0M9 11a3 3 0 1 1 6 0 3 3 0 0 1-6 0';